import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ToastService } from '@core/services/toast.service';
import { Router } from '@angular/router';
import { RoutingPathsTree } from '@core/constants/routing-paths-tree.const';
import { UsersService } from '@core/services/users.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private toastService: ToastService,
        private usersService: UsersService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage: string = '';

                if (error.status === 401 || error.status === 0) {
                    // error.status = 0 - could be a CORS
                    this.usersService.isAuthorize = false;
                    this.router.navigate([RoutingPathsTree.NoAccess.route]);
                    return throwError(() => error);
                }

                if (error.error?.messages) {
                    error.error?.messages.forEach(
                        (message: string) => (errorMessage += message)
                    );
                } else {
                    errorMessage = error.message;
                }

                this.toastService.openError(errorMessage);

                if (error.status === 403) {
                    this.router.navigate([RoutingPathsTree.Reports.route]);
                    return throwError(() => error);
                }

                return throwError(() => error);
            })
        );
    }
}
